import { render, staticRenderFns } from "./luckdraw.vue?vue&type=template&id=f8826b54&scoped=true&"
import script from "./luckdraw.vue?vue&type=script&lang=js&"
export * from "./luckdraw.vue?vue&type=script&lang=js&"
import style0 from "./luckdraw.vue?vue&type=style&index=0&id=f8826b54&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8826b54",
  null
  
)

export default component.exports